import { render, staticRenderFns } from "./OurFacilities.vue?vue&type=template&id=7db82d87&scoped=true&"
import script from "./OurFacilities.vue?vue&type=script&lang=js&"
export * from "./OurFacilities.vue?vue&type=script&lang=js&"
import style0 from "./OurFacilities.vue?vue&type=style&index=0&id=7db82d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db82d87",
  null
  
)

export default component.exports